import { CSSObject } from '@chakra-ui/react';

export const RaceMeetingsList: CSSObject = {
  px: '2',
  mx: [null, '3'],
};
